import { AnyAction } from 'redux';

import * as constants from 'redux/constants/services.constants';

export const onGetAll = (): AnyAction => ({
  type: constants.SERVICES_ON_GET_ALL_REQUESTED,
});
